export default function carHasPromo(
  { sold, sellingStatus, specialPromotion, promotion, testDrive, onlineScoring },
  locale
) {
  return (
    !sold &&
    (specialPromotion || promotion || testDrive || onlineScoring) &&
    /*
    Special case to ignore pre-owned cars. They may have a promo but we show the
    flash icon instead. This function is only used for CSS and the car has no
    visible promos.
    */
    !(sellingStatus === "pre-owned" && locale === "es")
  )
}
